<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-select
          :items="reportNames"
          filled
          data-cy="FormUserSignature-reportName"
          :label="$$t('reportName')"
          v-model="localFormUserSignature.reportName"
        />
        <v-select
          :items="users"
          item-text="email"
          item-value="id"
          filled
          data-cy="FormUserSignature-userId"
          :label="$$t('userId')"
          v-model="localFormUserSignature.userId"
        ></v-select>
        <v-text-field
          filled
          data-cy="FormUserSignature-role"
          :label="$$t('role')"
          v-model="localFormUserSignature.role"
        />
        <v-select
          :items="signatureTypes(localFormUserSignature.reportName)"
          filled
          data-cy="FormUserSignature-signatureType"
          :label="$$t('signatureType')"
          v-model="localFormUserSignature.signatureType"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormUserSignature-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormUserSignature-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'FormUserSignature',
  module: 'Signatures',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    FormUserSignature: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localFormUserSignature
      */
      localFormUserSignature: {
        reportName: '',
      },
    };
  },
  computed: {
    ...mapGetters('signatureChecks', ['signatureTypes', 'reportNames']),
    ...mapState('signatureChecks', ['checklists']),
    ...mapState('userManagement', ['users']),
  },
  watch: {
    FormUserSignature() {
      this.localFormUserSignature = this.FormUserSignature;
    },
  },
  async mounted() {
    await this.loadUsers();
  },
  created() {
    this.localFormUserSignature = this.FormUserSignature;
  },
  methods: {
    ...mapActions('userManagement', ['loadUsers']),
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localFormUserSignature);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormUserSignature example

'''js
<FormUserSignature :FormUserSignature="FormUserSignature" />
'''
</docs>
